import { BaseAPIModel } from '@weezevent/weezjs-core';
import { aliases } from '../i18n/i18n';

export default class Organization extends BaseAPIModel {
    static BUSINESS_ENTITY_SWITZERLAND = '5be16b35-27e1-4256-b907-44627a2b2f33';
    static BUSINESS_ENTITY_SPAIN = '375b5a03-5a12-47c1-897e-8ae24fb8bf0c';

    static BRAND_TICKET_PRO = 2;

    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    defaultLanguage() {
        const orgaLocale = this.default_locale?.replace('_', '-') || 'en-GB';
        const locale = aliases[orgaLocale] ?? orgaLocale;
        return locale;
    }

    has_feature(key) {
        return this.feature_flags && this.feature_flags.include(key);
    }

    isBrandTicketPro() {
        return this.brand_id === Organization.BRAND_TICKET_PRO;
    }

    isFranchise() {
        return this.is_franchise;
    }

    static listUrl() {
        return `/ticket/organizations`;
    }

    resend_bank_mail() {
        let url = `${this.constructor.listUrl({})}/${this.id}/send_bank_confirm`;
        return BaseAPIModel.fetcher.post(url, {});
    }

    toOption() {
        return {
            key: this.id,
            value: this.id,
            text: this.name ? `O${this.id} - ${this.name}` : `O${this.id}`
        };
    }
}
